import React, { FC } from 'react'

import { FormControl, InputLabel, Select } from '@mui/material'

interface IProps {
  data: boolean
  setValue: (column: string, value: string)=>void
  value: string
  children: React.ReactNode
  column: string
  label: string
}

const CustomSelect: FC<IProps> = ({ data, value, setValue, children, label,column }) => {
  return (
    <FormControl variant="outlined" size="small" disabled={data}>
      <InputLabel
        sx={{
          fontSize: '12px',
        }}
      >
        {label}
      </InputLabel>
      <Select
        value={value}
        label={label}
        onChange={(e) => setValue(column,e.target.value)}
        sx={{
          height: 32,
          fontSize: '12px',
          width: '100px',
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              fontSize: '12px',
            },
          },
        }}
      >
        {children}
      </Select>
    </FormControl>
  )
}

export default CustomSelect
